module.exports = __webpack_public_path__ + "static/media/icon_layer-partition.0a494d97.svg";